/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';

/**
 * The CollectionResponseResponseState model module.
 * @module model/CollectionResponseResponseState
 * @version version not set
 */
export class CollectionResponseResponseState {
  /**
   * Constructs a new <code>CollectionResponseResponseState</code>.
   * @alias module:model/CollectionResponseResponseState
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CollectionResponseResponseState</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CollectionResponseResponseState} obj Optional instance to populate.
   * @return {module:model/CollectionResponseResponseState} The populated <code>CollectionResponseResponseState</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CollectionResponseResponseState();
      if (data.hasOwnProperty('code'))
        obj.code = ApiClient.convertToType(data['code'], 'Number');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} code
 */
CollectionResponseResponseState.prototype.code = undefined;

/**
 * @member {String} message
 */
CollectionResponseResponseState.prototype.message = undefined;


